export const LOGIN_USER_BEGIN = 'LOGIN_USER_BEGIN'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE'
export const RESET_LOGIN_USER = 'RESET_LOGIN_USER'


export const SIGNUP_USER_BEGIN = 'SIGNUP_USER_BEGIN'
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS'
export const SIGNUP_USER_FAILURE = 'SIGNUP_USER_FAILURE'
export const RESET_SIGNUP_USER = 'RESET_SIGNUP_USER'


export const LOGOUT_USER_BEGIN = 'LOGOUT_USER_BEGIN'
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS'
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE'
export const RESET_LOGOUT_USER = 'RESET_LOGOUT_USER'

// Languages
export const GET_LANGUAGES_BEGIN = 'GET_LANGUAGES_BEGIN'
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS'
export const GET_LANGUAGES_FAILURE = 'GET_LANGUAGES_FAILURE'
export const RESET_GET_LANGUAGES = 'RESET_GET_LANGUAGES'

export const GET_FLUENCYLEVEL_BEGIN = 'GET_FLUENCYLEVEL_BEGIN'
export const GET_FLUENCYLEVEL_SUCCESS = 'GET_FLUENCYLEVEL_SUCCESS'
export const GET_FLUENCYLEVEL_FAILURE = 'GET_FLUENCYLEVEL_FAILURE'
export const RESET_GET_FLUENCYLEVEL = 'RESET_GET_FLUENCYLEVEL'

export const SET_FLUENCYLEVEL_BEGIN = 'SET_FLUENCYLEVEL_BEGIN'
export const SET_FLUENCYLEVEL_SUCCESS = 'SET_FLUENCYLEVEL_SUCCESS'
export const SET_FLUENCYLEVEL_FAILURE = 'SET_FLUENCYLEVEL_FAILURE'
export const RESET_SET_FLUENCYLEVEL = 'RESET_SET_FLUENCYLEVEL'

export const GET_USERFLUENCY_BEGIN = 'GET_USERFLUENCY_BEGIN'
export const GET_USERFLUENCY_SUCCESS = 'GET_USERFLUENCY_SUCCESS'
export const GET_USERFLUENCY_FAILURE = 'GET_USERFLUENCY_FAILURE'
export const RESET_GET_USERFLUENCY = 'RESET_GET_USERFLUENCY'

export const GET_REFERRALLINK_BEGIN = 'GET_REFERRALLINK_BEGIN'
export const GET_REFERRALLINK_SUCCESS = 'GET_REFERRALLINK_SUCCESS'
export const GET_REFERRALLINK_FAILURE = 'GET_REFERRALLINK_FAILURE'
export const RESET_GET_REFERRALLINK = 'RESET_GET_REFERRALLINK'


export const GET_REFFEREDUSERS_BEGIN = 'GET_REFFEREDUSERS_BEGIN'
export const GET_REFFEREDUSERS_SUCCESS = 'GET_REFFEREDUSERS_SUCCESS'
export const GET_REFFEREDUSERS_FAILURE = 'GET_REFFEREDUSERS_FAILURE'
export const RESET_GET_REFFEREDUSERS = 'RESET_GET_REFFEREDUSERS'

export const GOOGLE_LOGIN_USER_BEGIN = 'GOOGLE_LOGIN_USER_BEGIN'
export const GOOGLE_LOGIN_USER_SUCCESS = 'GOOGLE_LOGIN_USER_SUCCESS'
export const GOOGLE_LOGIN_USER_FAILURE = 'GOOGLE_LOGIN_USER_FAILURE'
export const RESET_GOOGLE_LOGIN_USER = 'RESET_GOOGLE_LOGIN_USER'

export const SEND_MESSAGE_BEGIN = 'SEND_MESSAGE_BEGIN'
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE'
export const RESET_SEND_MESSAGE = 'RESET_SEND_MESSAGE'

export const SEND_ASSESSMENT_MESSAGE_BEGIN = 'SEND_ASSESSMENT_MESSAGE_BEGIN'
export const SEND_ASSESSMENT_MESSAGE_SUCCESS = 'SEND_ASSESSMENT_MESSAGE_SUCCESS'
export const SEND_ASSESSMENT_MESSAGE_FAILURE = 'SEND_ASSESSMENT_MESSAGE_FAILURE'
export const RESET_SEND_ASSESSMENT_MESSAGE = 'RESET_SEND_ASSESSMENT_MESSAGE'

export const GET_MESSAGE_LIST_BEGIN = 'GET_MESSAGE_LIST_BEGIN'
export const GET_MESSAGE_LIST_SUCCESS = 'GET_MESSAGE_LIST_SUCCESS'
export const GET_MESSAGE_LIST_FAILURE = 'GET_MESSAGE_LIST_FAILURE'
export const RESET_GET_MESSAGE_LIST = 'RESET_GET_MESSAGE_LIST'

export const GET_MESSAGE_TRANSLATE_BEGIN = 'GET_MESSAGE_TRANSLATE_BEGIN'
export const GET_TRASNLATED_SUCCESS_DATA = 'GET_TRASNLATED_SUCCESS_DATA'
export const GET_TRASNLATED_FAILURE_DATA = 'GET_TRASNLATED_FAILURE_DATA'

export const GET_USER_LANGUAGE_BEGIN = 'GET_USER_LANGUAGE_BEGIN'
export const GET_USER_LANGUAGE_SUCCESS = 'GET_USER_LANGUAGE_SUCCESS'
export const GET_USER_LANGUAGE_FAILURE = 'GET_USER_LANGUAGE_FAILURE'
export const RESET_GET_USER_LANGUAGE = 'RESET_GET_USER_LANGUAGE'

export const GET_USERLANGUAGE_BEGIN = 'GET_USERLANGUAGE_BEGIN'
export const GET_USERLANGUAGE_SUCCESS = 'GET_USERLANGUAGE_SUCCESS'
export const GET_USERLANGUAGE_FAILURE = 'GET_USERLANGUAGE_FAILURE'
export const RESET_GET_USERLANGUAGE = 'RESET_GET_USERLANGUAGE'

export const GET_AUDIOLINK_BEGIN = 'GET_AUDIOLINK_BEGIN'
export const GET_AUDIOLINK_SUCCESS = 'GET_AUDIOLINK_SUCCESS'
export const GET_AUDIOLINK_FAILURE = 'GET_AUDIOLINK_FAILURE'
export const RESET_GET_AUDIOLINK = 'RESET_GET_AUDIOLINK'



